import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dede084"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "CountTotalNumber",
  class: "count"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "CountCustomerNumberPie",
  class: "count"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "CountCustomerNumberBar",
  class: "count"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "CountSupplierNumberPie",
  class: "count"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "CountSupplierNumberBar",
  class: "count"
}, null, -1))
const _hoisted_7 = {
  key: 0,
  id: "CountCustomNumber",
  class: "count"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "empty-text"
}
const _hoisted_10 = ["id"]
const _hoisted_11 = {
  key: 0,
  class: "empty-text"
}
const _hoisted_12 = ["id"]
const _hoisted_13 = ["id"]
const _hoisted_14 = {
  key: 0,
  class: "empty-text"
}
const _hoisted_15 = ["id"]
const _hoisted_16 = ["id"]
const _hoisted_17 = {
  key: 0,
  class: "empty-text"
}
const _hoisted_18 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_miezz_month_choose = _resolveComponent("miezz-month-choose")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_miezz_dynamic_search = _resolveComponent("miezz-dynamic-search")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, { class: "left" }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_select, {
          modelValue: _ctx.serviceType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.serviceType) = $event)),
          options: _ctx.EnumOrderServiceTypeOption,
          clearable: "",
          onHandleChange: _ctx.handleChooseServiceType,
          style: {"margin-bottom":"10px"}
        }, null, 8, ["modelValue", "options", "onHandleChange"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item, i) => {
          return (_openBlock(), _createBlock(_component_el_alert, {
            key: i,
            title: item.title,
            type: item.type,
            effect: "dark",
            closable: false,
            center: item.type == 'success',
            class: _normalizeClass(item.code == _ctx.type ? 'active' : ''),
            onClick: ($event: any) => (_ctx.handleChooseType(item.code))
          }, null, 8, ["title", "type", "center", "class", "onClick"]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_miezz_month_choose, {
        modelValue: _ctx.month,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.month) = $event))
      }, null, 8, ["modelValue"]),
      (_ctx.type == 'CountTotalNumber')
        ? (_openBlock(), _createBlock(_component_miezz_card, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_alert, {
                title: "统计数据每10分钟更新一次，不包含未关联订单的委托书数据",
                type: "info",
                effect: "light",
                closable: false
              }),
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.type == 'CountCustomerNumber')
        ? (_openBlock(), _createBlock(_component_miezz_card, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_alert, {
                title: "统计数据每10分钟更新一次，不包含未关联订单的委托书数据",
                type: "info",
                effect: "light",
                closable: false
              }),
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.type == 'CountCustomerNumber')
        ? (_openBlock(), _createBlock(_component_miezz_card, { key: 2 }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.companyId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyId) = $event)),
                  options: _ctx.companies,
                  className: "choose",
                  onHandleChange: _ctx.handleChart
                }, null, 8, ["modelValue", "options", "onHandleChange"])
              ]),
              _hoisted_4
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.type == 'CountSupplierNumber')
        ? (_openBlock(), _createBlock(_component_miezz_card, { key: 3 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_alert, {
                title: "统计数据每10分钟更新一次，不包含未关联订单的委托书数据",
                type: "info",
                effect: "light",
                closable: false
              }),
              _hoisted_5
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.type == 'CountSupplierNumber')
        ? (_openBlock(), _createBlock(_component_miezz_card, { key: 4 }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.supplierId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.supplierId) = $event)),
                  options: _ctx.suppliers,
                  className: "choose",
                  onHandleChange: _ctx.handleChart
                }, null, 8, ["modelValue", "options", "onHandleChange"])
              ]),
              _hoisted_6
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.type == 'CountCustomNumber' || _ctx.type == 'CountCustomGoods')
        ? (_openBlock(), _createBlock(_component_miezz_card, { key: 5 }, {
            default: _withCtx(() => [
              _createVNode(_component_miezz_dynamic_search, {
                id: "miezz-dynamic-search",
                modelValue: _ctx.dto.DynamicSearchId,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dto.DynamicSearchId) = $event)),
                items: _ctx.searchs,
                simple: false,
                fixProp: false,
                hideCompare: false,
                histories: _ctx.histories,
                code: "Count_Pool",
                onHandleSearch: _ctx.handleChart,
                onHandleGetHistories: _ctx.handleGetHistories
              }, {
                "dynamic-search-customize": _withCtx(({ model }) => [
                  (model.Where.Prop == 'DynamicSearch_ClientCompanyId')
                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                        key: 0,
                        modelValue: model.Where.Value,
                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                        options: _ctx.companies,
                        clearable: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                    : _createCommentVNode("", true),
                  (model.Where.Prop == 'DynamicSearch_SupplierCompanyId')
                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                        key: 1,
                        modelValue: model.Where.Value,
                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                        options: _ctx.suppliers,
                        clearable: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                    : (model.Where.Prop == 'DynamicSearch_ContainerTypeId')
                      ? (_openBlock(), _createBlock(_component_miezz_select, {
                          key: 2,
                          modelValue: model.Where.Value,
                          "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                          options: _ctx.containerTypes,
                          clearable: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                      : (model.Where.Prop == 'DynamicSearch_Area')
                        ? (_openBlock(), _createBlock(_component_miezz_select, {
                            key: 3,
                            modelValue: model.Where.Value,
                            "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                            options: _ctx.areas,
                            clearable: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        : _createCommentVNode("", true),
                  (model.Where.Prop == 'DynamicSearch_LoadingPortId')
                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                        key: 4,
                        modelValue: model.Where.Value,
                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                        options: _ctx.loadingPorts,
                        clearable: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                    : (model.Where.Prop == 'DynamicSearch_DeliveryPortId')
                      ? (_openBlock(), _createBlock(_component_miezz_select, {
                          key: 5,
                          modelValue: model.Where.Value,
                          "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                          options: _ctx.deliveryPorts,
                          clearable: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                      : (model.Where.Prop == 'DynamicSearch_TransportDirection')
                        ? (_openBlock(), _createBlock(_component_miezz_select, {
                            key: 6,
                            modelValue: model.Where.Value,
                            "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                            options: _ctx.EnumTransportDirectionOption,
                            number: true,
                            clearable: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue", "items", "histories", "onHandleSearch", "onHandleGetHistories"]),
              (_ctx.type == 'CountCustomNumber')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                : _createCommentVNode("", true),
              (_ctx.type == 'CountCustomGoods')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.countCustomGoodsBarOptions.length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 暂无数据 "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countCustomGoodsBarOptions, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        id: `CountCustomGoodsBar_${i}`,
                        class: "count",
                        style: {"width":"50%"}
                      }, null, 8, _hoisted_10))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.type == 'CountTotalGoods')
        ? (_openBlock(), _createBlock(_component_miezz_card, { key: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_alert, {
                title: "统计数据每10分钟更新一次，不包含未关联订单的委托书数据",
                type: "info",
                effect: "light",
                closable: false
              }),
              (_ctx.countTotalGoodsBarOptions.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 暂无数据 "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countTotalGoodsBarOptions, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  id: `CountTotalGoodsBar_${i}`,
                  class: "count",
                  style: {"width":"50%"}
                }, null, 8, _hoisted_12))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.type == 'CountCustomerGoods')
        ? (_openBlock(), _createBlock(_component_miezz_card, { key: 7 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_alert, {
                title: "统计数据每10分钟更新一次，不包含未关联订单的委托书数据",
                type: "info",
                effect: "light",
                closable: false
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countCustomerGoodsOptions, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  id: `CountCustomerGoodsPie_${i}`,
                  class: "count",
                  style: {"width":"50%"}
                }, null, 8, _hoisted_13))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.type == 'CountCustomerGoods')
        ? (_openBlock(), _createBlock(_component_miezz_card, { key: 8 }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.companyId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.companyId) = $event)),
                  options: _ctx.companies,
                  className: "choose",
                  onHandleChange: _ctx.handleChart
                }, null, 8, ["modelValue", "options", "onHandleChange"])
              ]),
              (_ctx.countCustomerGoodsBarOptions.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 暂无数据 "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countCustomerGoodsBarOptions, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  id: `CountCustomerGoodsBar_${i}`,
                  class: "count",
                  style: {"width":"50%"}
                }, null, 8, _hoisted_15))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.type == 'CountSupplierGoods')
        ? (_openBlock(), _createBlock(_component_miezz_card, { key: 9 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_alert, {
                title: "统计数据每10分钟更新一次，不包含未关联订单的委托书数据",
                type: "info",
                effect: "light",
                closable: false
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countSupplierGoodsOptions, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  id: `CountSupplierGoodsPie_${i}`,
                  class: "count",
                  style: {"width":"50%"}
                }, null, 8, _hoisted_16))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.type == 'CountSupplierGoods')
        ? (_openBlock(), _createBlock(_component_miezz_card, { key: 10 }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.supplierId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.supplierId) = $event)),
                  options: _ctx.suppliers,
                  className: "choose",
                  onHandleChange: _ctx.handleChart
                }, null, 8, ["modelValue", "options", "onHandleChange"])
              ]),
              (_ctx.countSupplierGoodsBarOptions.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 暂无数据 "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countSupplierGoodsBarOptions, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  id: `CountSupplierGoodsBar_${i}`,
                  class: "count",
                  style: {"width":"50%"}
                }, null, 8, _hoisted_18))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}